<template>
  <v-menu
    v-model="menu"
    offset-y
    bottom
    nudge-left="25%"
    :disabled="!modal"
    rounded="xl"
    nudge-bottom="10"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        class="transparent mx-3"
        :color="modal && menu ? 'green' : 'black'"
        text
        elevation="0"
        v-bind="attrs"
        :href="to"
        :target="target"
        v-on="on"
      >
        <span class="text-center size-22">{{ label }}</span>
        <v-icon v-if="modal" right>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(button, index) in buttonsModal" :key="index">
        <v-list-item-title>
          <v-btn block text :href="'/planos/#' + button.name">
            {{ button.button }}
          </v-btn>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: 'HeaderButton',
  props: {
    label: { type: String },
    to: { type: String },
    modal: { type: Boolean },
    target: { type: String },
  },
  data() {
    return {
      menu: false,
      buttonsModal: [
        { button: 'Residencial', name: 'residencial' },
        { button: 'Gamer', name: 'gamer' },
        { button: 'Rural', name: 'rural' },
        { button: 'Dedicado', name: 'dedicado' },
      ],
    }
  },
}
</script>
<style scoped lang="scss">
::v-deep .v-btn {
  font-size: 1.375rem;
}
</style>
